import type { MessagingGetChatRooms200PageAllOf } from './messagingGetChatRooms200PageAllOf';
import type { MessagingGetChatRooms200PageAllOfThree } from './messagingGetChatRooms200PageAllOfThree';

export type MessagingGetChatRooms200Page = MessagingGetChatRooms200PageAllOf & MessagingGetChatRooms200PageAllOfThree;
